import React from "react";
import { iconSrc } from "@innovid/core-agent-ui";
import { useFlag } from "@innovid/feature-flags-react";
import { FEATURE_FLAGS } from "featureFlag/featureFlag";

import "./AgentNavItem.css";

function AgentNavItem({ classes }){
	const isNivoChatEnabled = useFlag(FEATURE_FLAGS.HOPI_NIVO_CHAT);

	const handleClick = () => {
		const agent = document.querySelector("core-agent");
		if(agent){
			if(agent.isOpen()){
				agent.close();
			} else {
				agent.open();
			}
		}
	};

	if(!isNivoChatEnabled){ return null; }

	return (
		<div className={`nivo-nav-item ${classes}`}>
			<button onClick={handleClick} title="Toggle AI agent">
				<img src={iconSrc} alt="AI agent" />
			</button>
		</div>
	);
}

AgentNavItem.displayName = "AgentNavItem";

export default AgentNavItem;
